import React, { Fragment, useState } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import { Grid } from '@mui/material';
import ItemStoreCreateView from '../../../components/inventory/setup/item_store/ItemStoreCreateView';
import ItemStoreListView from '../../../components/inventory/setup/item_store/ItemStoreListView';

const ItemStoreCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.InventoryURL + 'inventory/product/item/store/create/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };
    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <ItemStoreCreateView handleFormSuccess={handleFormSuccess} />
                </Grid>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <ItemStoreListView handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} results={data} error={error} loading={loading} />
                </Grid>
            </Grid>

        </Fragment>
    )
}

export default ItemStoreCreateListView